import React from 'react'
import banner1 from '../Images/banner1.png'

function Banner() {
  return (
    <>

    <img src={banner1} style={{ objectFit: "cover", width: "100%" }} />



  </>
  )
}

export default Banner